// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"fce90159","545":"02473d2a","787":"5ff97a29"}[chunkId] + ".chunk.js";
};